document.addEventListener('DOMContentLoaded', function () {
  var tabSections = document.querySelectorAll('[data-havaianas-col-style-tabs]');

  tabSections.forEach(function (tabsRoot) {
    var section = tabsRoot.closest('.havaianas-col-style-tabs-section');
    if (!section) return;

    var tabs = tabsRoot.querySelectorAll('.havaianas-col-style-tabs__tab');
    var panels = tabsRoot.querySelectorAll('.havaianas-col-style-tabs__panel');
    var prevButton = section.querySelector('[data-tabs-prev]');
    var nextButton = section.querySelector('[data-tabs-next]');
    var activeIndex = parseInt(tabsRoot.getAttribute('data-initial-index') || '0', 10);
    var isAnimating = false;
    var transitionDuration = 420;

    if (!tabs.length || !panels.length) return;

    function cleanupPanel(panel) {
      panel.classList.remove(
        'is-active',
        'is-entering',
        'is-leaving',
        'is-animating',
        'from-next',
        'from-prev',
        'to-next',
        'to-prev'
      );
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
    }

    function setTabState(index, focusTab) {
      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive && focusTab) {
          tab.focus();
        }
      });
    }

    function showInitial(index) {
      panels.forEach(function (panel, panelIndex) {
        if (panelIndex === index) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          cleanupPanel(panel);
        }
      });

      setTabState(index, false);
      activeIndex = index;
    }

    function goTo(index, direction, focusTab) {
      if (isAnimating) return;
      if (index === activeIndex) return;

      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      var currentPanel = panels[activeIndex];
      var nextPanel = panels[index];
      if (!currentPanel || !nextPanel) return;

      isAnimating = true;

      setTabState(index, focusTab);

      nextPanel.removeAttribute('hidden');
      nextPanel.setAttribute('aria-hidden', 'false');

      currentPanel.removeAttribute('hidden');
      currentPanel.setAttribute('aria-hidden', 'false');

      nextPanel.classList.remove('is-active', 'is-leaving', 'to-next', 'to-prev');
      currentPanel.classList.remove('is-entering', 'from-next', 'from-prev');

      nextPanel.classList.add('is-entering');
      currentPanel.classList.add('is-leaving');

      if (direction === 'prev') {
        nextPanel.classList.add('from-prev');
        currentPanel.classList.add('to-prev');
      } else {
        nextPanel.classList.add('from-next');
        currentPanel.classList.add('to-next');
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          nextPanel.classList.add('is-animating');
          currentPanel.classList.add('is-animating');
        });
      });

      window.setTimeout(function () {
        cleanupPanel(currentPanel);

        nextPanel.classList.remove(
          'is-entering',
          'is-animating',
          'from-next',
          'from-prev'
        );
        nextPanel.classList.add('is-active');
        nextPanel.removeAttribute('hidden');
        nextPanel.setAttribute('aria-hidden', 'false');

        activeIndex = index;
        isAnimating = false;
      }, transitionDuration);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        var direction = index > activeIndex ? 'next' : 'prev';
        if (index === activeIndex) return;
        goTo(index, direction, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1, 'next', true);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1, 'prev', true);
        }

        if (event.key === 'Home') {
          event.preventDefault();
          if (activeIndex !== 0) goTo(0, 'prev', true);
        }

        if (event.key === 'End') {
          event.preventDefault();
          if (activeIndex !== tabs.length - 1) goTo(tabs.length - 1, 'next', true);
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(activeIndex - 1, 'prev', false);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(activeIndex + 1, 'next', false);
      });
    }

    showInitial(activeIndex);
  });
});